import React, {useState} from 'react';
import {Tab, Tabs, TabList, TabPanels, TabPanel} from "@carbon/react";


const TabbedContainer = ({
                           tabs,
                           defaultSelectedIndex = 0,
                           className = '',
                           ariaLabel = 'Tab container',
                           tabContentClassName = '',
                           contained = false,
                           preSelectedIndex = null,
                           shouldShowTabPanel = true,
                         }) => {
  const [selectedIndex, setSelectedIndex] = useState(defaultSelectedIndex);

  const localSelectedIndex = Number.isInteger(preSelectedIndex) ? preSelectedIndex : selectedIndex;
  return (
    <div className={`tabbed-container ${className}`}>
      <Tabs
        selectedIndex={localSelectedIndex}
        aria-label={ariaLabel}
        tabContentClassName={tabContentClassName}
      >
        {shouldShowTabPanel && <TabList contained={contained} aria-label={ariaLabel}>
          {tabs.map((tab, index) => (
            <Tab
              id={`tab-${index}`}
              key={`tab-${index}`}
              data-testid={tab.label}
              label={tab.label}
              disabled={tab.disabled}
              onClick={() => {
                tab.onClick ? tab.onClick() : setSelectedIndex(index);
              }}
            >
              {tab.label}
            </Tab>
          ))}
        </TabList>}
        {tabs.every(tab => tab.content) &&<TabPanels>
          {tabs.map((tab, index) => (
            <TabPanel key={`tab-panel-${index}`}>
              <div className="tab-content">
                {tab.content}
              </div>
            </TabPanel>
          ))}
        </TabPanels>}
      </Tabs>
    </div>
  );
};

export default TabbedContainer;
